'use client';

import { isSignOutInProgress } from '@/shared/auth/sign-out';
import { signalWorkerPushSessionEnding, startWorkerPushRegistrationSync } from '@/shared/auth/worker-push';
import { useIsSafeonFlutterClient } from '@/shared/forced-mobile/ForcedMobileProvider';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

export function WorkerPushRegistrationSync() {
  const { data: session, status, update } = useSession();
  const isFlutterClient = useIsSafeonFlutterClient();
  const identity = session?.mobileAuth?.mobile_context;
  const identityKey = identity ? [identity.user_uid, identity.field_uid, identity.device_uid, identity.session_uid].join(':') : '';
  const refreshState = session?.refreshState;

  useEffect(() => {
    if (!isFlutterClient || status === 'loading') return;
    if (status !== 'authenticated' || !identityKey || refreshState === 'terminal' || isSignOutInProgress()) {
      signalWorkerPushSessionEnding();
      return;
    }
    if (refreshState === 'retryable') return;
    return startWorkerPushRegistrationSync(() => {
      void update();
    });
  }, [identityKey, isFlutterClient, refreshState, status, update]);

  return null;
}
